import { useEffect, useState } from 'react';
import flatten from 'flat';
import { IntlShape, createIntl } from 'react-intl';
import { getPhraseTranslations } from 'contexts/serviceSettings';
import Fallback, { FallbackProps } from './Fallback';

type Props = {
  title: (intl: IntlShape) => string;
  body: (intl: IntlShape) => string;
  button: (intl: IntlShape) => string;
  intl?: IntlShape;
  onClick: FallbackProps['onClick'];
};

const getTranslations = (locale: string) =>
  getPhraseTranslations(locale)
    .then(t => flatten<typeof t, Record<string, string>>(t))
    .then(messages => ({ locale, messages }));

const FallbackScreen = ({ title, body, button, onClick, intl: _intl }: Props) => {
  const [intl, setIntl] = useState<undefined | IntlShape>(_intl);

  useEffect(() => {
    if (!intl) {
      const systemLocale = navigator.language;

      getTranslations(systemLocale)
        .catch(() => getTranslations('en-GB'))
        .then(data => createIntl(data))
        .then(setIntl);
    }
  }, [intl]);

  return (
    intl && (
      <Fallback
        fullscreen
        title={title(intl)}
        body={body(intl)}
        button={button(intl)}
        onClick={onClick}
      />
    )
  );
};

export default FallbackScreen;
